import * as React from 'react';
import NotificationBanner from 'components/Notification';
import { Link, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useLocation } from 'react-router';

 export default function RegistryNotification() {
  const location = useLocation();
  const isVisible = !location.pathname.startsWith("/registry")
  return (
    <>
    { isVisible ?
    <NotificationBanner color="success">
      Having trouble finding our registry? Please click <Link href="/registry" underline='always' sx={(theme) => ({color: theme.palette.grey[300]})}>HERE <OpenInNewIcon fontSize="small" sx={{verticalAlign: "middle"}}/></Link>
    </NotificationBanner>
    : <></> }
    </>
  );
}
